import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Box, FormControl, Select, MenuItem, Typography } from '@mui/material';

interface CreditAmountSectionProps {
  control: Control<Gift.Crud>;
  dictionary: any;
}

const CreditAmountSection: React.FC<CreditAmountSectionProps> = ({ control, dictionary }) => {

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'medium', color: 'text.secondary' }}>
        Tribute Credits to Send
      </Typography>
      <Controller
        name="creditAmount"
        control={control}
        defaultValue={1}
        render={({ field }) => (
          <FormControl fullWidth>
            <Select
              {...field}
              displayEmpty
              inputProps={{ 'aria-label': 'Select number of tribute credits' }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '10px',
                },
              }}
            >
              <MenuItem value={1}>1 Credit - $49.95</MenuItem>
              <MenuItem value={2}>2 Credits - $99.90</MenuItem>
              <MenuItem value={3}>3 Credits - $149.85</MenuItem>
            </Select>
          </FormControl>
        )}
      />
    </Box>
  );
};

export default CreditAmountSection;
